import { NgModule } from '@angular/core'
import { CmsConfig, provideConfig, UserConsentAdapter } from '@spartacus/core'
import { EbBreadcrumbModule } from '../components/breadcrumb/eb-breadcrumb.module'
import { EbAuthModule } from './auth/eb-auth.module'
import { EbCartModule } from './cart/eb-cart.module'
import { ebCheckoutConfig } from './checkout/eb-checkout.config'
import { EbCmsModule } from './cms/eb-cms.module'
import { EbConfigModule } from './config/eb-config.module'
import { EbFavoritesModule } from './favorites/eb-favorites.module'
import { EbFooterModule } from './footer/eb-footer.module'
import { EbFormModule } from './form/eb-form.module'
import { EbGlobalMessageModule } from './global-message/eb-global-message.module'
import { EbHeaderModule } from './header/eb-header.module'
import { EbI18nModule } from './i18n/eb-i18n.module'
import { EbUserConsentAdapter } from './myaccount/consent-management/services/eb-user-consent.adapter'
import { ebMyAccountLayoutConfig } from './myaccount/eb-my-account-layout.config'
import { EbOrderFeatureModule } from './order/eb-order-feature.module'
import { EbProductModule } from './product/eb-product.module'
import { EbSeoModule } from './seo/eb-seo.module'
import { EbSiteContextModule } from './site-context/eb-site-context.module'
import { EbPartnersModule } from './support/contact-card/eb-partners.module'
import { EbUserModule } from './user/eb-user.module'

@NgModule({
  imports: [
    EbSiteContextModule,
    EbFooterModule,
    EbHeaderModule,
    EbCartModule,
    EbProductModule,
    EbUserModule,
    EbAuthModule,
    EbPartnersModule,
    EbFormModule,
    EbGlobalMessageModule,
    EbCmsModule,
    EbBreadcrumbModule,
    EbConfigModule,
    EbOrderFeatureModule,
    EbFavoritesModule,
    EbSeoModule,
    EbI18nModule.forRoot()
  ],
  providers: [
    provideConfig(ebCheckoutConfig),
    provideConfig(ebMyAccountLayoutConfig),
    { provide: UserConsentAdapter, useClass: EbUserConsentAdapter },
    provideConfig({
      featureModules: {
        ebMyAccount: {
          cmsComponents: ['ConsentManagementComponent'],
          module: () => import('./myaccount/eb-my-account.module').then(m => m.EbMyAccountModule)
        },
        ebUserProfile: {
          cmsComponents: ['UserDetailsComponent'],
          module: () =>
            import('./user/components/profile/eb-update-profile-form.module').then(
              m => m.EbUpdateProfileFormModule
            )
        },
        ebFavoritesPage: {
          cmsComponents: ['FavoritesListsComponent', 'FavoritesListsDetailsComponent'],
          module: () =>
            import('./favorites/eb-favorites-page.module').then(m => m.EbFavoritesPageModule)
        },
        ebProductComponents: {
          cmsComponents: [
            'ProductSummaryComponent',
            'ProductImagesComponent',
            'ProductGridComponent',
            'SearchResultsGridComponent',
            'ProductListComponent',
            'SearchResultsListComponent',
            'VariantsListComponent',
            'SuccessorComponent',
            'ProductSpecsTabComponent',
            'ProductRefinementComponent'
          ],
          module: () =>
            import('./product/eb-product-components.module').then(m => m.EbProductComponentsModule)
        },
        ebContactForm: {
          cmsComponents: ['ebContactFormComponent'],
          module: () =>
            import('./support/contact-form/eb-contact-form.module').then(m => m.EbContactFormModule)
        },
        ebRfpForm: {
          cmsComponents: ['ebRfPFormComponent'],
          module: () => import('./support/rfp-form/eb-rfp-form.module').then(m => m.EbRfpFormModule)
        }
      }
    } as CmsConfig)
  ]
})
export class EbFeaturesModule {}
